import { MentionMetadataTypesEnum } from '../enums/mention-metadata-types.enum';

export const mentionMetadataDefaultOrder = [
    MentionMetadataTypesEnum.outlet,
    MentionMetadataTypesEnum.author,
    MentionMetadataTypesEnum.publishedDate,
    MentionMetadataTypesEnum.audienceReach,
    MentionMetadataTypesEnum.ave,
    MentionMetadataTypesEnum.sentiment,
    MentionMetadataTypesEnum.location,
    MentionMetadataTypesEnum.wordCount,
    MentionMetadataTypesEnum.duration,
    MentionMetadataTypesEnum.domainAuthority,
    MentionMetadataTypesEnum.keywords,
    MentionMetadataTypesEnum.engagement,
    MentionMetadataTypesEnum.mediaType,
    MentionMetadataTypesEnum.image
];
